import { z } from 'zod'

import { isCalendarMonth } from '@/pages/analyzer-insights/format-month'
import { rejectedValue } from '@/pages/analyzer-insights/search-rejection'

const validMonth = z.coerce.number().int().min(200001).max(209912).refine(isCalendarMonth)

export const analyzerInsightsUsersSearchSchema = z.object({
  month: z.union([validMonth, rejectedValue]).optional().catch(undefined),
})

export type AnalyzerInsightsUsersSearch = z.infer<typeof analyzerInsightsUsersSearchSchema>
